import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isoWeek);

export const getParamsForCurrentWeek = () => ({ start_date: undefined, end_date: undefined, completed: false });

export const getParamsForPreviousWeeks = () => {
  const today = dayjs();

  const startDate = dayjs(today.startOf('isoWeek').subtract(2, 'week')).format('YYYY-MM-DD');

  const endDate = dayjs(today.startOf('isoWeek').add(4, 'day').endOf('day')).format('YYYY-MM-DD');

  return { start_date: startDate, end_date: endDate, completed: true };
};
